import axios from 'axios';

const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const BASE = `${process.env.REACT_APP_BACKEND_URL}/fipe`;

export interface FipeBrand {
  id: string;
  code: string;
  name: string;
  vehicleType: string;
}

export interface FipeModel {
  id: string;
  code: string;
  name: string;
  marca: { code: string; name: string; vehicleType: string };
}

export interface FipePagedResult<T> {
  totalItems: number;
  page: number;
  limit: number;
  items: T[];
}

export const fetchFipeVehicleYears = async (type?: string): Promise<number[]> => {
  const { data } = await axios.get<number[]>(`${BASE}/vehicle-years`, {
    params: type ? { type } : {},
    withCredentials: true,
    headers: authHeader(),
  });
  return data;
};

export const fetchFipeBrands = async (params: {
  type?: string;
  modelYear?: number;
  search?: string;
  page?: number;
  limit?: number;
}): Promise<FipePagedResult<FipeBrand>> => {
  const { data } = await axios.get<FipePagedResult<FipeBrand>>(`${BASE}/brands`, {
    params,
    withCredentials: true,
    headers: authHeader(),
  });
  return data;
};

export const fetchFipeModels = async (params: {
  brandCode?: string;
  type?: string;
  modelYear?: number;
  search?: string;
  page?: number;
  limit?: number;
}): Promise<FipePagedResult<FipeModel>> => {
  const { data } = await axios.get<FipePagedResult<FipeModel>>(`${BASE}/models`, {
    params,
    withCredentials: true,
    headers: authHeader(),
  });
  return data;
};
